import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import $ from 'jquery'

class BookingAdditional extends React.Component {
  state = {
    users_data: [],
    model: false,
    popBookID: '',
    userdata: [
      {
        bookingNo: 'BOOK7560008',
        product: 'IceCream',
        packagePrice: '4580',
        quantity: 5,
        bookID: '5826585826595',
      },
    ],
  }
  componentDidMount() {}

  handleStatusChange = (sid) => {
    var isChecked = $('#Captain_active_status_' + sid)
    isChecked.prop('checked', !isChecked.prop('checked'))
    var status = false
    if (!isChecked.prop('checked') === true) {
      status = true
    } else {
      status = false
    }

    var that = this
    var data = new URLSearchParams()
    // this.setState({ isSaving: true });
    data.append('active', status)
    data.append('CaptainShopId', sid)
    fetch(Constant.getAPI() + '/shop/toggleActive', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('waves_ad_auth'),
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
      body: data,
    })
      .then((res) => {
        return res.json()
      })
      .then((json) => {
        if (json.success === true) {
          Swal.fire('Update Status!', 'Status has been updated.', 'success')
          that.getVendorsList()
        } else {
          Swal.fire({
            title: 'Something went wrong. Try again after some Time.!',
            icon: 'error',
            text: '',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'bookingNo',
        label: 'Booking NO',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'product',
        label: 'Product',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'packagePrice',
        label: 'Price',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'quantity',
        label: 'Quantitiy',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'status',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (status) => {
            return <span className="badge badge-pill badge-success">{status}</span>
          },
        },
      },
      //   {
      //     name: "bookID",
      //     label: "Action",
      //     options: {
      //       filter: true,
      //       sort: true,
      //       customBodyRender: (bookID, tableMeta) => {
      //         return (
      //           <div>
      //             <Link
      //               to={"/bookdetails/" + bookID}
      //               className="m-r-15 text-muted"
      //               data-toggle="tooltip"
      //               data-placement="top"
      //               title=""
      //               data-original-title="View "
      //             >
      //               <i className="f-22 icofont icofont-eye text-dark"></i>
      //             </Link>
      //           </div>
      //         );
      //       },
      //     },
      //   },
    ]
    const options = {
      // filterType: "dropdown",
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No BookingAdditional Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Additional List</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Additional List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Additional List'}
                          className="table-responsive"
                          data={this.state.userdata}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BookingAdditional
